// removed by extract-text-webpack-plugin
module.exports = {"ui":"language_ui_1ot5lv"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/language/language.scss
// module id = 570
// module chunks = 0